<div [class]="'skeleton w-full ' +  (classList ?? '')" [style]="ratio + height" [ngClass]="{'h-full' : isFullHeight}" ></div>
